import React from 'react';
import { Row, Col, Table, Form } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';

import { CurrencyPlainText } from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import flatten from 'helpers/flatten';
import BootstrapTable from 'react-bootstrap-table-next';
import { renderToString } from 'react-dom/server';
import Select from 'react-select';
import Moment from 'moment';

const ListingReportsUser = ({
  reports,
  filters,
  stateFilters,
  handleFilterChange,
}) => {
  const { t } = useTranslation();
  const handlePageChange = (page) => handleFilterChange({ page });

  const sortCaretDefaut = (order, column) => {
    if (!order) return (<i style={{float:'right'}} className="fas fa-sort"></i>);
    else if (order === 'asc') return (<i style={{float:'right'}} className="fas fa-sort-down"></i>);
    else if (order === 'desc') return (<i style={{float:'right'}} className="fas fa-sort-up"></i>);
    return null;
  };

  const columns = [
    { 
      text: 'Nome',
      dataField: 'name',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: field})
      }
    },
    {
      text: 'E-mail',
      dataField: 'email',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: field })
      }
    },
    {
      text: 'Telefone',
      dataField: 'phone',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: field })
      }
    },
    {
      text: 'Perfil',
      dataField: 'profile',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: field })
      }
    },
    {
      text: 'Data de Criação',
      dataField: 'created_at',
      headerStyle: {
        textAlign: 'center',
      },
      style: {
        textAlign: 'center'
      },
      sort: true,
      sortCaret: sortCaretDefaut,
      onSort: (field, order) => {
        handleFilterChange({ order: order, field: 'name' })
      }
    },
  ];

  function btn(id) {
    return <i className="fas fa-plus-circle btne" id={id}></i>; //<i className="fas fa-minus-circle"></i>;
  }

  const reportsData = [];
  let detailsArray = [];

  function getTableExport(btn_export) {
    let teste = [];
    var t = (
      <>
        <thead>
          <tr>
            <th>Nome</th>
            <th>E-mail</th>
            <th>Telefone</th>
            <th>Perfil</th>
            <th>Data de Criação</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(reports.data_export).map((report) => {
            var item = {
              id: report.id,
              name: report.firstname + ' ' + report.lastname,
              email: report.email,
              phone: report.phone != null ? report.phone : '---',
              profile:
                report.profiles.length > 0 ? report.profiles[0].name : '---',
              created_at:
                report.created_at != null
                  ? Moment(report.created_at).format('DD/MM/Y')
                  : '---',
            };
            return (
              <tr>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.phone}</td>
                <td>{item.profile}</td>
                <td>{item.created_at}</td>
              </tr>
            );
          })}
        </tbody>
      </>
    );
    document.getElementById('table-to-xls').innerHTML = renderToString(t);
    btn_export.disabled = false;
  }

  async function getReports() {
    let teste = [];
    Object.values(reports.data).map(report => {
      teste = reportsData.push({
        id: report.id,
        name: report.firstname + ' ' + report.lastname,
        email: report.email,
        phone: report.phone != null ? report.phone : '---',
        profile: report.profiles.length > 0 ? report.profiles[0].name : '---',
        created_at:
          report.created_at != null
            ? Moment(report.created_at).format('DD/MM/Y')
            : '---',
      });
    });

    var btn_export = document.getElementById('btn-to-excel');
    if (btn_export != null) {
      await getTableExport(btn_export);
    }
  }

  getReports();

  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col md={2}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={(e) =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Perfis:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.profile}
                  onChange={(e) =>
                    handleFilterChange({ profile: e.target.value, page:1 })
                  }
                >
                  <option value="">Todos</option>
                  {Object.values(reports.profiles).map((report) => {
                    return <option value={report.id}>{report.name}</option>;
                  })}
                </Form.Control>
              </Form.Group>
            </Col>
            {filters.map((filter, k) => (
              <Col key={k} md={2}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={(e) =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1,
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.search}
                  onChange={(e) =>
                    handleFilterChange({ search: e.target.value, page:1 })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <BootstrapTable
                id="vendor-report-table"
                keyField="id"
                data={reportsData}
                columns={columns}
                bordered
                hover
                classes="table-condensed"
                wrapperClasses='table-responsive'
                rowStyle={{ fontSize: '13px' }}
                noDataIndication="Usuário não Encontrado"
                //expandRow={expandRow}
              />
              <table
                bordered
                hover
                responsive
                id="table-to-xls"
                style={{ display: 'none' }}
              ></table>
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: reports.from || '0' }} to{' '}
                {{ to: reports.to || '0' }} from {{ total: reports.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={reports.current_page}
                itemsCountPerPage={reports.per_page}
                totalItemsCount={reports.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ListingReportsUser;
